import * as React from 'react';
import { useFormikContext } from 'formik';
import Workflow from '../../../models/be/Workflow';
import ErrorMessage from '../../../commonComponents/ErrorMessage';
import { hiddenErrorKey } from './form';

const BirthDatesMatchValidator = (props: Props) => {
	const { errors, setFieldError, values } = useFormikContext<Workflow & { [hiddenErrorKey]: string }>();

	const isValid = birthDatesMatch({ ...(props.visibleWorkflowFields ?? ({} as Workflow)), ...values });

	const errorMessage = 'BirthDatesMatchValidatorError';
	if (!isValid && errors[hiddenErrorKey] !== errorMessage) {
		setTimeout(() => {
			setFieldError(hiddenErrorKey, errorMessage);
		}, 0);
	}

	return (
		<>
			{!isValid && (
				<ErrorMessage
					message={
						<p>The date of birth provided on your passport and driving licence must match your date of birth.</p>
					}
				/>
			)}
		</>
	);
};

export default BirthDatesMatchValidator;

interface Props {
	visibleWorkflowFields?: Workflow;
}

const birthDatesMatch = (workflow: Workflow | undefined) => {
	const passportVisible = workflow?.customFields?.passportQuestion === true;
	const driverLicenceVisible = workflow?.customFields?.driverLicenceQuestion === true;

	const primary = workflow?.birthDetails?.birthDate;
	const passport = passportVisible ? workflow?.passportDetails?.birthDate : undefined;
	const driverLicence = driverLicenceVisible ? workflow?.driverLicenceDetails?.birthDate : undefined;

	const dates = [primary, passport, driverLicence].filter((d) => !!d);
	if (dates.length <= 1) return true;

	return dates.every((d) => d === dates[0]);
};
